// src/utils/arrayUtils.js - Utility functions for array manipulation

/**
 * Shuffles array elements using Fisher-Yates (Knuth) shuffle algorithm
 * @param {Array} array - The array to shuffle
 * @returns {Array} A new shuffled array (does not mutate original)
 */
export const shuffleArray = (array) => {
  const shuffled = [...array]; // Create a copy to avoid mutating original
  
  for (let i = shuffled.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[i]];
  }
  
  return shuffled;
};